export interface AppConfig {

    /**
     * URL of GMQ API.
     */
    apiUrl: string,
    /**
     * Scope registered for GMQ API with Identity Server 
     */
    apiScope: string,
    /**
     * ClientId registered for GMQ with Identity Server
     */
    clientId: string,

    /**
     * Identity Server URL
     */
    identityServerUrl: string,

    /**
     * Base path of the application
     */
    baseUrl:string;


    /**
     * enable auth to be turned on/off
     */
    disableAuth?: boolean,

    /**
     * Roles mapping
     */
    roles: {
        actuary: string[];
        am: string[];
    };

    /**
     * Sentry config
     */
    sentry: {
        dsn: string;
        env: string;
    }
}

export const getAppConfig = (): AppConfig => (window as any).appConfig;